import React from "react";
import {
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
  FaFacebookF,
} from "react-icons/fa";
import {
  FooterContainer,
  FooterH2,
  FooterLink,
  FooterWrapper,
  SocialIconsWrapper,
  SocialIcon,
  FooterBottom,
  CopyrightText,
  FooterBottomLink,
} from "./FooterElements";
import "./../../App.css";

const Footer = () => {
  return (
    <FooterContainer>
      <FooterWrapper className="container py-5">
        <div className="row gx-5 px-4 gy-4">
          <div className="col-lg-3 col-sm-6">
            <FooterH2>Company</FooterH2>
            <FooterLink href="#">About Us</FooterLink>
            <FooterLink href="#">Our Team</FooterLink>
            <FooterLink href="#">Careers</FooterLink>
            <FooterLink href="#">Blog</FooterLink>
          </div>
          <div className="col-lg-3 col-sm-6">
            <FooterH2>Services</FooterH2>
            <FooterLink href="#">Branding</FooterLink>
            <FooterLink href="#">Websites</FooterLink>
            <FooterLink href="#">Digital Marketing</FooterLink>
            <FooterLink href="#">Web Designed</FooterLink>
            <FooterLink href="#">Social Media</FooterLink>
            <FooterLink href="#">SEO</FooterLink>
            <FooterLink href="#">Bespoke</FooterLink>
            <FooterLink href="#">Enterprise</FooterLink>
          </div>
          <div className="col-lg-3 col-sm-6">
            <FooterH2>Contact Us</FooterH2>
            <FooterLink href="#">Get a Quote</FooterLink>
            <FooterLink href="#">Support</FooterLink>
            <FooterLink href="#">hello@esandev.in</FooterLink>
            <FooterLink href="#">+91 89039 11001</FooterLink>
          </div>
          <div className="col-lg-3 col-sm-6">
            <FooterH2>Follow Us</FooterH2>
            <SocialIconsWrapper>
              <SocialIcon href="#" aria-label="Instagram">
                <FaInstagram />
              </SocialIcon>
              <SocialIcon href="#" aria-label="Twitter">
                <FaTwitter />
              </SocialIcon>
              <SocialIcon href="#" aria-label="YouTube">
                <FaYoutube />
              </SocialIcon>
              <SocialIcon href="#" aria-label="LinkedIn">
                <FaLinkedin />
              </SocialIcon>
              <SocialIcon href="#" aria-label="Facebook">
                <FaFacebookF />
              </SocialIcon>
            </SocialIconsWrapper>
          </div>
        </div>
        <FooterBottom>
          <CopyrightText>© 2025 ESAN DEV - All Rights Reserved</CopyrightText>
          <FooterBottomLink href="#">Terms and Conditions</FooterBottomLink>
          <FooterBottomLink href="#">Cookie Policy</FooterBottomLink>
          <FooterBottomLink href="#">Privacy Policy</FooterBottomLink>
        </FooterBottom>
      </FooterWrapper>
    </FooterContainer>
  );
};

export default Footer;
